// @flow
import { keyBy } from 'lodash';

import {
  railsApiActionTypes as ActionType,
  railsApiTypes as Types,
  apiActionTypes as ApiActionTypes
} from '../constants';

const initialState = {
  appGroups: [],
  apps: [],
  eventMappings: [],
  attributesMappings: {},
  attributesMappingsFetched: {},
  showErrors: false,
  errorResponse: {
    message: ''
  }
};

export default function RailsApiReducer(
  state: Types.InitialState = initialState,
  action: Types.Action
) {
  switch (action.type) {
    case ActionType.APP_GROUPS_SUCCESS: {
      const appGroups = action.response;
      return {
        ...state,
        appGroups,
        appGroupsById: keyBy(appGroups, 'id')
      };
    }
    case ActionType.APPS_SUCCESS: {
      const apps = action.response;
      return {
        ...state,
        apps: keyBy(apps, 'uuid')
      };
    }
    case ActionType.EVENT_MAPPINGS_SUCCESS: {
      const eventMappings = action.response;
      return {
        ...state,
        eventMappings,
        eventMappingsById: keyBy(eventMappings, 'id'),
        eventMappingFetched: true
      };
    }
    case ActionType.ATTRIBUTES_MAPPINGS_SUCCESS: {
      const { response: attributeMappings, payload: { eventId } } = action;
      const copy = { ...state };
      copy.attributesMappings[eventId] = attributeMappings;
      copy.attributesMappingsFetched[eventId] = true;
      return copy;
    }
    case ActionType.APPS_FAILURE:
    case ActionType.APP_GROUPS_FAILURE:
    case ActionType.ATTRIBUTES_MAPPINGS_FAILURE:
    case ActionType.EVENT_MAPPINGS_FAILURE: {
      const error =
        'Unable to load data for this page.  Please try again or contact support.';
      return {
        ...state,
        showErrors: true,
        errorResponse: { message: error }
      };
    }
    case ApiActionTypes.HIDE_ERRORS: {
      return {
        ...state,
        showErrors: false
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/railsApi.js